// extracted by mini-css-extract-plugin
export default {"LoadingPage":"LoadingPage_LoadingPage__A2qZu"};